export const PICKER_CONTAINER_PADDING = 15
export const PICKER_INFO_MARGIN_LEFT = 8
export enum PickerPosition {
  BelowTarget = "BelowTarget",
  AboveTarget = "AboveTarget",
}
